import { useTranslation } from '@testsigma/atoms';
import warningIcon from '@images/exclamatin-warning.svg';

const RefreshMetadataWarningScreen: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col items-center justify-center h-full'>
      <div className='leading-8 font-semibold text-secondary-1000 text-2xl'>
        {t('header.metadata_in_progress')}
      </div>

      <div className='mt-6 mb-9'>
        <img
          src={warningIcon}
          className='empty-illustration'
          alt='Tick Illustration'
        />
      </div>

      <div className='flex mb-10 text-center text-sm text-secondary-text'>
        {t('message.metadata_warning')}
      </div>
    </div>
  );
};

export { RefreshMetadataWarningScreen };
